/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Stores
 * 
 * 1 = Procurement
 * 
 * 2 = Sales
 * 
 * 3 = Operations
 * 
 * 4 = MachineShop
 */
export enum TeamRole {
  Stores = 0,
  Procurement = 1,
  Sales = 2,
  Operations = 3,
  MachineShop = 4
}
